window.FullFillRoomForm = function (node) {
    let datePicker = node.closest('.js-datepicker');
    if(document.querySelector('.js-room-detail-form-input')) {
        document.querySelector('.js-room-detail-form-input').value = datePicker.querySelector('.js-datepicker-from').value + ' - ' + datePicker.querySelector('.js-datepicker-to').value + ', počet osob: ' + datePicker.querySelector('#personCount').value + ', počet dětí: ' + datePicker.querySelector('#childrenCount').value;
    }
}